import { render, staticRenderFns } from "./ReportsMetricDetail.vue?vue&type=template&id=0f83f273&scoped=true"
import script from "./ReportsMetricDetail.vue?vue&type=script&lang=js"
export * from "./ReportsMetricDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportsMetricDetail.vue?vue&type=style&index=0&id=0f83f273&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f83f273",
  null
  
)

export default component.exports